import { jsx as _jsx } from "react/jsx-runtime";
import useViewport from '../../hooks/useViewport';
var Padding = function (_a) {
    var data = _a.data;
    var visualViewport = useViewport().visualViewport;
    var isMobile = visualViewport.width < 768;
    var isTablet = visualViewport.width < 1024 && visualViewport.width >= 768;
    var isDesktop = visualViewport.width >= 1024;
    return (_jsx("div", { style: {
            backgroundColor: "" + data.background_color,
            width: '100%',
            height: "" + (isDesktop
                ? data.desktop_padding + "px"
                : isTablet
                    ? data.tablet_padding + "px"
                    : isMobile
                        ? data.mobile_padding + "px"
                        : ''),
        } }, void 0));
};
export default Padding;
